// /ProfilePage/utils.js

export const isValidUrl = (url) => {
  try {
    // eslint-disable-next-line no-new
    new URL(url); // Informa ao linter para ignorar esta linha
    return true;
  } catch {
    return false;
  }
};

export const getInitials = (name) => {
  if (!name || typeof name !== 'string') return '';
  const nameParts = name.trim().split(' ').filter(Boolean);
  if (nameParts.length === 0) return '';
  if (nameParts.length === 1) return nameParts[0].charAt(0).toUpperCase();
  const firstInitial = nameParts[0].charAt(0);
  const lastInitial = nameParts[nameParts.length - 1].charAt(0);
  return `${firstInitial}${lastInitial}`.toUpperCase();
};

export const formatDisplayName = (name) => {
  if (!name || typeof name !== 'string') return '';
  const nameParts = name.trim().split(' ').filter(Boolean);
  if (nameParts.length <= 1) return name || '';
  return `${nameParts[0]} ${nameParts[nameParts.length - 1]}`;
};

export const getRoleLabel = (tipo) => {
  if (tipo === undefined || tipo === null) return 'Carregando...';
  const tipoStr = String(tipo).toLowerCase();
  return tipoStr === 'administrador' || tipoStr === 'true'
    ? 'Administrador'
    : 'Usuário';
};
